var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonStatistics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512.001 512.001",
    height: 512,
    viewBox: "0 0 512.001 512.001",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m111.401 222.8h289.2c19.902-.793 19.887-29.215 0-30h-274.2v-43.054l65.333-65.333 69.727 69.726c5.856 5.857 15.355 5.859 21.213 0l102.927-102.926v44.121c.793 19.902 29.215 19.887 30 0v-80.333c0-8.284-6.716-15-15-15h-80.333c-19.902.793-19.887 29.215 0 30h44.12l-92.32 92.32-69.727-69.726c-5.857-5.857-15.355-5.858-21.213 0l-54.727 54.727v-92.321c-.793-19.902-29.215-19.887-30 0v192.8c0 8.284 6.716 14.999 15 14.999z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.034 328.834c0-30.713-24.987-55.7-55.7-55.7-73.894 3.06-73.873 108.352 0 111.4 30.714 0 55.7-24.987 55.7-55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.368 328.834c0-30.713-24.987-55.7-55.7-55.7-73.894 3.06-73.873 108.352 0 111.4 30.713 0 55.7-24.987 55.7-55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.701 328.834c0-30.713-24.987-55.7-55.7-55.7-73.894 3.06-73.873 108.352 0 111.4 30.713 0 55.7-24.987 55.7-55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.08 405.638c-61.089-50.046-155.452-5.423-155.079 74.23v17.133c0 8.284 6.716 15 15 15h118.247c-1.665-4.695-2.58-9.741-2.58-15v-17.133c0-27.761 9.078-53.437 24.412-74.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.668 384.534c-22.602 0-43.388 7.912-59.746 21.104 15.335 20.793 24.412 46.469 24.412 74.229v17.133c0 5.258-.915 10.305-2.58 15h118.247c8.284 0 15-6.716 15-15v-17.133c0-52.567-42.766-95.333-95.333-95.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.001 384.534c-52.567 0-95.333 42.767-95.333 95.333v17.133c0 8.284 6.716 15 15 15h160.667c8.284 0 15-6.716 15-15v-17.133c-.001-52.567-42.767-95.333-95.334-95.333z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonStatistics);
export default __webpack_public_path__ + "static/media/common_statistics.cfb8ac0c.svg";
export { ForwardRef as ReactComponent };